;( function( $ ) {

	/**
	 * Building state flag
	 *
	 * @var {Boolean}
	 */
	var _building_paused = false;
	var _package_building_started = 'shipper-package-building-started';
	var _logging_timer = null;

	function stop_prop( e ) {
		if ( e && e.stopPropagation ) e.stopPropagation();
		if ( e && e.preventDefault ) e.preventDefault();
		return false;
	}

	function show_modal( id, replace_modal ) {
		var replace_modal    = replace_modal ? true : false;
		var modal_id          = get_modal_id( id );
		var focus_after_closed = this;
		var focus_when_open    = undefined;
		var has_overlay_mask   = false;
		var modal            = get_modal( id );

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

	    return modal;
	}

	function get_modal_id( id ) {
		return 'shipper-package-build-' + id;
	}

	function get_modal( id ) {
		return $( '#' + get_modal_id( id ) );
	}

	function send_request( action, obj ) {
		var dfr = new $.Deferred();
		obj = obj || {};
		obj.action = 'shipper_packages_build_' + action;
		$.post( ajaxurl, obj )
			.done( function( resp ) {
				var status = ( resp || {} ).success,
					data = ( resp || {} ).data;
				if ( status ) {
					return dfr.resolveWith( this, [data] );
				}
				return dfr.rejectWith( this, [data] );
			} )
			.fail( function( resp, type, error ) {
				var json = resp.responseJSON || {},
					msg = ( json || {} ).data || error;
				if ( typeof "" !== typeof msg ) {
					msg = error;
				}
				dfr.rejectWith( this, [msg] );
			} );
		return dfr.promise();
	}

	function update_progress( percentage, msg ) {
		percentage = ( parseInt( percentage, 10 ) || 1 ) + '%';
		get_modal( 'migration' )
			.find( '.shipper-progress-label' ).text( percentage ).end()
			.find( '.shipper-progress-bar' ).css( 'width', percentage ).end();
		if ( msg ) {
			get_modal( 'migration' ).find( '.shipper-progress-status' ).text( msg );
		}
	}

	function finalize_package() {
		var $active = get_modal( 'migration' )
			.find( '.shipper-progress-check' )
				.removeClass( 'active' )
				.last().addClass( 'active' );
		update_progress(
			50,
			$active.find( '.shipper-progress-title' ).text() + '...'
		);

		send_request( 'done' )
			.done( function() {
				update_progress( 100, 'Done' );
				var url = document.location;

				// Package build is done. So clear the package building started sate.
				clear_package_building_started();

				if ( url.search.includes( '?page=shipper-packages&start=true' ) ) {
					url.search = '?page=shipper-packages';
				} else {
					window.location.reload();
				}
			} )
			.fail( function( error ) {
				show_error_dialog( error );
			} );
	}

	function process_package() {
		if ( _building_paused ) {
			return false;
		}

		// Package building is started, so record it.
		set_package_building_started();

		send_request( 'build' )
			.done( function( percentage ) {
				update_progress( percentage );
				if ( percentage < 100 ) {
					return setTimeout( process_package, 100 );
				}

				stop_logging();
				return setTimeout( finalize_package, 100 );
			} )
			.fail( function( error ) {
				stop_logging();
				show_error_dialog( error );
			} );
	}

	function start_building( e ) {
		_building_paused = false;
		var replace_modal = true;

		show_modal( 'migration', replace_modal );
		send_request( 'prepare' )
			.done( function( percentage ) {
				update_progress( percentage );
				process_package();
				start_logging();
			} )
			.fail( function( error ) {
				show_error_dialog( error );
				stop_logging();
			} );
		return stop_prop( e );
	}

	function cancel_building( e ) {
		send_request( 'cancel' )
			.done( function() {
				window.location.reload();
			} )
			.fail( function( error ) {
				show_error_dialog( error );
			} );
		return stop_prop( e );
	}

	function continue_building( e ) {
		_building_paused = false;
		var replace_modal = true;
		show_modal( 'migration', replace_modal );
		process_package();
		return stop_prop( e );
	}

	function show_cancel_dialog( e, replace_modal ) {
		_building_paused = true;

		show_modal( 'cancel', replace_modal )
			.find( '.shipper-goback' )
				.off( 'click' )
				.on( 'click', continue_building ).end()
			.find( '.shipper-cancel' )
				.off( 'click' )
				.on( 'click', cancel_building ).end()
		return stop_prop( e );
	}

	function show_error_dialog( error ) {
		// There is an error, so clear the package building state and send a failed request.
		clear_package_building_started();
		send_failed_request();

		show_modal( 'fail' )
			.find( '.shipper-error-message-wrapper' ).hide().end()
			.find( '.shipper-restart' )
			.off( 'click' )
			.on( 'click', start_building );

		if ( ( error || {} ).length ) {
			get_modal( 'fail' ).find( '.shipper-error-message-wrapper' ).show()
				.find( '.shipper-error-message' )
					.html(
						'<code style="color: #ff0000">' + error + '</code>'
					);
		}
	}

	/**
	 * Send failed request when a package creation has been field for any reason.
	 *
	 * @since 1.2.5
	 */
	function send_failed_request() {
		send_request( 'failed' )
	}

	/**
	 * Save package building started state.
	 *
	 * @since 1.2.5
	 */
	function set_package_building_started() {
		window.localStorage.setItem( _package_building_started, 'true' );
	}

	/**
	 * Check whether the package building was started or not.
	 *
	 * @since 1.2.5
	 *
	 * @return boolean
	 */
	function get_package_building_started() {
		return window.localStorage.getItem( _package_building_started ) === 'true';
	}

	/**
	 * Clear the package building started state.
	 *
	 * @since 1.2.5
	 */
	function clear_package_building_started() {
		window.localStorage.removeItem( _package_building_started );
	}

	function update_log( message ) {
		var log_area = $( '.shipper-package-progress-logs .sui-notice-message' );

		log_area.slideUp( 350 , function() {
			log_area.find( 'p' ).remove();
			log_area.append( '<p>' + message + '</p>' );
			log_area.show( 350 );
		});
	}

	/**
	 * Send logging request
	 *
	 * @since 1.2.7
	 */
	function send_log_request() {
		send_request( 'logs' )
			.done( function( data ) {
				if ( ! data || ! data.message ) {
					return;
				}

				update_log( data.message );
			});
	}

	/**
	 * Start logging
	 *
	 * @since 1.2.7
	 */
	function start_logging() {
		_logging_timer = setInterval( function() {
			send_log_request();
		}, 5000 );
	}

	/**
	 * Stop logging
	 *
	 * @since 1.2.7
	 */
	function stop_logging() {
		clearInterval( _logging_timer );
	}

	function init() {
		if ( ! $( '.shipper-packages-migration-main' ).length ) {
			return false;
		}

		$( window ).on( 'beforeunload', function() {
			if ( get_package_building_started() ) {
				// So package building was started and user reloaded or closed the window.
				// Let's clear the package building started state and send a failed request.
				send_failed_request();
				clear_package_building_started();
			}
		});

		$( document ).on(
			'shipper-package-build',
			start_building
		);
		$( document ).on( 'click', '#shipper-package-build .shipper-cancel', function(e) {
			var replace_modal = true;
			show_cancel_dialog( e, replace_modal );
		});
	}

	$( init );

} )( jQuery );
